




















import { defineComponent, ref, useFetch } from '@nuxtjs/composition-api'
import { PropType } from 'vue';
import { ProductForProductPageType } from '~/utils/types/ProductPage';
import BrightcoveVideo from '../BrightcoveVideo.vue';
import { useCategoryStore } from '~/modules/catalog/category/stores/category';
import { getProductTopicBgColor } from '~/utils/solepro/products';
import PlayPause from './PlayPause.vue';

export default defineComponent({
    props: {
        product: {
            type: Object as PropType<ProductForProductPageType>
        },
    },
    components: {
        BrightcoveVideo,
        PlayPause
    },
    setup(props) {
        const bgColor = ref('#F7F7F7');
        const isPlaying = ref()
        const isSSR = ref(true)
        useFetch(async () => {

            const categoriesStore = useCategoryStore();
            await categoriesStore.load()
            const categories = categoriesStore.rawCategories?.items[0].children
            bgColor.value = getProductTopicBgColor(categories, props.product, '#F7F7F7')
        })
        return {
            bgColor,
            video: props.product.mediaGallery.find(el=>el.video_content && el.video_content.video_url),
            isPlaying,
            isSSR
        }
    },
    mounted() {
        this.isSSR = false
    },
    methods: {
        getEmbeddableURL(url) {
            if (url && url.includes('dropbox')) {
                return url.replace("dropbox.com", "dl.dropboxusercontent.com").replace('&dl=0','&dl=1');
            } else {
                return url;
            }
        },
        togglePlay() {
            const video = this.$el.querySelector('video');
            this.isPlaying ? video.pause&&video.pause() : video.play&&video.play();
        },
        onPlay(){
            this.isPlaying = true;
        },
        onPause(){
            this.isPlaying = false;
        }
    }
})
